const groupVpsHostingPackagesFields = (fields) => {
  const introFields = fields
    .filter((field) => field.key === 'eyebrow' || field.key === 'title' || field.key === 'intro')
    .sort((a, b) => a.sortOrder - b.sortOrder);

  const packageGroups = [];

  for (let index = 1; index <= 20; index += 1) {
    const groupFields = fields
      .filter((field) => field.key.startsWith(`package-${index}-`))
      .sort((a, b) => a.sortOrder - b.sortOrder);

    if (!groupFields.some((field) => field.key === `package-${index}-name`)) {
      break;
    }

    packageGroups.push({ index, fields: groupFields });
  }

  return { introFields, packageGroups };
};

export default groupVpsHostingPackagesFields;
